import PropTypes from 'prop-types';
import { Link, Route, Routes } from 'react-router-dom';

// Third-parties.
import Helmet from 'react-helmet';

// Components.
import Breadcrumb from "../../../container/breadcrumb";
import ConditionalRender from "../../../helpers/ConditionalRender";
import HeaderActions from "../../../container/header_actions";
import List from "./List";
import Details from "./Details";
import { stringFormatting } from "../../../helpers/utils";

function ExtendedStatistics(props: { toggleMenu: Function }) {

    return (
        <div id="content">

            <Helmet>
                <title>SQL Statistics - DBmarlin</title>
                <meta name="description" content="Collect Extended SQL Statistics"/>
            </Helmet>

            {/* Heading */}
            <div id="top-header-wrapper" className="row row-cols-lg-3 row-cols-sm-1 row-cols-md-2">
                <Breadcrumb heading="SQL Statistics">
                    <Link to="/admin">Settings</Link>

                    <Routes>
                        <Route path="/admin/database-extended-statistics"
                               element={() => <span>SQL Statistics</span>}/>
                    </Routes>

                    <Routes>
                        <Route path="/admin/database-extended-statistics/:actionId/:id" element={() =>
                            <Link to="/admin/database-extended-statistics/">Update SQL Statistics</Link>}/>
                    </Routes>

                    <Routes>
                        <Route path="/admin/database-extended-statistics/:actionId/:id" element={(props: any) =>
                            <span>{stringFormatting(props.match.params.id)}</span>}/>
                    </Routes>
                </Breadcrumb>
               <HeaderActions toggleMenu={props.toggleMenu}/>
            </div>

            <div className="loader">
                <ConditionalRender if={false}>
                    <div className="bar"/>
                </ConditionalRender>
            </div>

            <div className="row row-cols-1">
                <Routes>
                    <Route path="/:actionId/:instanceId"
                           element={<Details />}/>
                    <Route path="/" element={<List/>}/>
                </Routes>
            </div>

        </div>
    );
}

ExtendedStatistics.propTypes = {
    toggleMenu: PropTypes.func.isRequired
};

export default ExtendedStatistics;